import "./style.scss";
import { useEffect, useState, useContext } from "react";
import useMisAutorizaciones from "./hooks/useMisAutorizaciones";
import HeaderFilters from "./components/HeaderFilters";
import ListadoDesktop from "./components/ListadoDesktop";
import CardMobile from "./components/CardMobile";
import ModalMensajes from "./components/ModalMensajes";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import { myAxios } from "../../../utils/fetch";
import { capitalize } from "../../../utils/capitalize";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const MisAutorizacionesComponent = () => {
  const { user } = useContext(UserGlobalContextMemorySpace);

  const {
    results,
    loader,
    total,
    offset,
    limit,
    filtroEstado,
    filtroIntegrante,
    filtroTexto,
    setFiltroEstado,
    setFiltroIntegrante,
    setFiltroTexto,
    setActiveDni,
    cargarAutorizaciones,
    siguiente,
    anterior,
  } = useMisAutorizaciones();

  const [familyGroupList, setFamilyGroupList] = useState(null);
  const [familyItem, setFamilyItem] = useState(
    capitalize(
      user.user.data.Customers.firstName +
        " " +
        user.user.data.Customers.lastName
    )
  );
  const [autorizacionSeleccionada, setAutorizacionSeleccionada] = useState(null);

  useEffect(() => {
    document.body.style.overflow = autorizacionSeleccionada ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [autorizacionSeleccionada]);

  useEffect(() => {
    myAxios({
      url:
        process.env.REACT_APP_GATEWAY_2 +
        "/customers/api/v1/familiargroup/getfamiliargroupbyid",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
      data: { idCustomer: user.user.data.Customers.idCustomer },
    })
      .then((response) => {
        const familyGroup = response.data.data.FamilyGroup.map((f) => ({
          id: f.idSap ?? "",
          name: capitalize(f.fullName),
          dni: f.dni ?? "",
        }));
        setFamilyGroupList([
          {
            id: user.user.data.Customers.idSap,
            name: capitalize(
              user.user.data.Customers.firstName +
                " " +
                user.user.data.Customers.lastName
            ),
            dni: user.user.data.Customers.dni ?? "",
          },
          ...familyGroup,
        ]);
      })
      .catch(() => {})
      .finally(() => {
        cargarAutorizaciones();
      });
  }, []);

  const handleChangePaciente = (id, name, text) => {
    setFamilyItem(text);
    const isPrincipal = id === familyGroupList?.[0]?.id;
    if (isPrincipal) {
      // Re-select principal: clear all filters, reload with principal's DNI
      setFiltroIntegrante("");
      setActiveDni("");
    } else {
      const selected = (familyGroupList ?? []).find((o) => o.id === id);
      const memberDni = selected?.dni ?? "";
      if (memberDni) {
        // Member has own DNI → server-side re-fetch
        setFiltroIntegrante("");
        setActiveDni(memberDni);
      } else {
        // No DNI available → client-side name filter fallback
        setActiveDni("");
        setFiltroIntegrante(text);
      }
    }
    cargarAutorizaciones(0);
  };

  const handleVerDetalle = (item) => {
    setAutorizacionSeleccionada(item);
  };

  const handleCerrarModal = () => {
    setAutorizacionSeleccionada(null);
  };

  return (
    <section>
      <div className="container p-4" id="container-mis-autorizaciones">
        <div className="row container-label-results mb-3">
          <div className="col-lg-5">
            <h2 className="section_hb_title title-results">
              <b className="section_hb_title">Mis autorizaciones</b>
            </h2>
          </div>
        </div>

        <HeaderFilters
          filtroTexto={filtroTexto}
          filtroEstado={filtroEstado}
          familyGroupList={familyGroupList}
          familyItem={familyItem}
          setFiltroTexto={setFiltroTexto}
          setFiltroEstado={setFiltroEstado}
          onChangePaciente={handleChangePaciente}
        />

        <div className="d-block d-md-none w-100" style={{ marginTop: "15px" }}>
          <div className="separador-table-red-result" style={{ marginBottom: "20px" }}></div>
          {loader ? (
            <div className="text-center" style={{ padding: "30px 0" }}>
              <span className="spinner-grow spinner-grow-sm"></span>
              <span className="spinner-grow spinner-grow-sm"></span>
              <span className="spinner-grow spinner-grow-sm"></span>
            </div>
          ) : results.length > 0 ? (
            <div className="mt-2">
              {results.map((item, i) => (
                <CardMobile key={i} item={item} onVerDetalle={handleVerDetalle} />
              ))}
              {total > 0 && results.length > 0 && (
                <div className="d-flex justify-content-center my-3">
                  <Stack spacing={2}>
                    <Pagination
                      count={Math.ceil(total / limit)}
                      page={Math.floor(offset / limit) + 1}
                      onChange={(_e, page) => {
                        if (page > Math.floor(offset / limit) + 1) siguiente();
                        else anterior();
                      }}
                      color="primary"
                      size="small"
                      siblingCount={1}
                      boundaryCount={1}
                      hidePrevButton={Math.ceil(total / limit) === 1}
                      hideNextButton={Math.ceil(total / limit) === 1}
                      sx={{
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: "#E0E0E0",
                          color: "#000",
                          "&:hover": { backgroundColor: "#d5d5d5" },
                        },
                      }}
                    />
                  </Stack>
                </div>
              )}
            </div>
          ) : (
            <p
              className="section_hb_title"
              style={{ fontSize: "16px", textAlign: "center", padding: "20px 0" }}
            >
              No se encontraron resultados con esas opciones de búsqueda.
                <br /> Intente con otros parámetros, o contáctese con nuestro equipo de{" "}
                <a
                  href="mailto:soportewebhb@hbritanico.com.ar"
                  className="section_hb_title"
                  style={{ fontSize: "16px", textDecoration: "underline" }}
                >
                  Soporte
                </a>
            </p>
          )}
        </div>

        <div className="d-none d-md-block w-100">
          <ListadoDesktop
            results={results}
            loader={loader}
            total={total}
            offset={offset}
            limit={limit}
            onVerDetalle={handleVerDetalle}
            onSiguiente={siguiente}
            onAnterior={anterior}
          />
        </div>
      </div>

      <ModalMensajes
        autorizacion={autorizacionSeleccionada}
        onClose={handleCerrarModal}
        nombreUsuario={capitalize(
          user.user.data.Customers.firstName +
            " " +
            user.user.data.Customers.lastName
        )}
      />
    </section>
  );
};

export default MisAutorizacionesComponent;
